// Shared Recharts theme tokens. One source of truth for the dark chart styling
// that was previously copy-pasted into every page, so all charts stay
// consistent and the per-chart prop objects can be hoisted to stable
// references (important: inline style/prop objects make Recharts re-render).

export const CHART_COLORS = {
  // Primary data series: calm off-white on dark. Lime (#CCFF00) is reserved
  // for the brand mark and primary actions, never for data.
  primary: "#E4E4E7",
  brand: "#CCFF00",
  blue: "#60a5fa",
  red: "#f87171",
  orange: "#f97316",
  green: "#34d399",
  violet: "#a78bfa",
  grid: "#1f1f1f",
  axis: "#52525b",
  axisText: "#71717a",
  tooltipText: "#a1a1aa",
  surface: "#0d0d0d",
  border: "#27272a",
} as const;

// Recharts animates on every data change by default, which is the single
// biggest source of runtime jank on data-heavy dashboards. Off = snappy.
export const ANIMATION_ACTIVE = false;

// Chart text uses the numeric face (Outfit; see DESIGN_SYSTEM §type). Tick
// labels get tabular figures from the `.recharts-cartesian-axis-tick-value`
// rule in tokens.css, so a column of ticks stays aligned.
export const CHART_FONT = "var(--pb-font-num)";

// Stable prop objects — reused across all charts so React/Recharts can bail out
// of re-rendering when nothing else changed.
export const AXIS_TICK = { fill: CHART_COLORS.axisText, fontSize: 11, fontFamily: CHART_FONT } as const;
export const GRID_PROPS = { strokeDasharray: "3 3", stroke: CHART_COLORS.grid } as const;
export const TOOLTIP_CONTENT_STYLE = {
  backgroundColor: CHART_COLORS.surface,
  border: `1px solid ${CHART_COLORS.border}`,
  borderRadius: 6,
  fontSize: 12,
  fontFamily: CHART_FONT,
  fontVariantNumeric: "tabular-nums",
} as const;
export const TOOLTIP_LABEL_STYLE = { color: CHART_COLORS.tooltipText, fontSize: 11, fontFamily: CHART_FONT } as const;
export const LEGEND_STYLE = { fontSize: 11, color: CHART_COLORS.tooltipText, fontFamily: CHART_FONT } as const;

export const inr = (v: number, opts?: Intl.NumberFormatOptions) =>
  `₹${v.toLocaleString("en-IN", { maximumFractionDigits: 0, ...opts })}`;
